export const HELP_ROUTE_PATH = '/help';
export const HELP_MOUSE_KEYBOARD_ROUTE_PATH =
  `${HELP_ROUTE_PATH}/mouse-keyboard` as const;
export const HELP_SCHEMA_ROUTE_PATH = `${HELP_ROUTE_PATH}/schema` as const;
